import { ISelectedCustomer } from "../../pages/Customers/CustomerGroup/Component/AddGroup/AddNewGroup";
import { paserParams } from "../../until";
import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";
import { SortType } from "../carLine/carLineApi";
import { ICustomer } from "../Customer_V2/customerApi_V2";
import { ITag } from "../selectOptions/selectOptionsApi";

export interface IVoucher {
    // cũ

    // id: number
    // code: string
    // title: string
    // description: string
    // dateStart: string
    // timeStart: string
    // dateEnd: string
    // timeEnd: string
    // quantity: number
    // orderValue: number
    // reducedAmount: number
    // percentDecrease: number
    // reducedAmountMaximum: number
    // usageCount: number
    // role: number
    // type: number
    // view: number
    // status: number

    // mới

    id: number
    code: string
    title: string
    description: string
    quantity: number
    releasedQuantity: number
    redeemedVoucherQuantity: number
    typeVoucherId: number
    orderValueMin: number
    reducedAmount?: number
    percentDecrease?: number
    reducedAmountMaximum?: number
    usageCount: number
    dateStart: string
    dateEnd: string
    approvalDate: string
    role: number
    type: string
    view: number
    status: number
    issuedUnit: string
    approvedUnit: string
    appliedUnits: string
    appliedBrands: string
    appliedActivities: string
}

export interface IVoucherEdit {
    id: number
    code: string
    title: string
    adminId: number
    description: string
    quantity: number
    unreleasedQuantity: number
    releasedQuantity: number
    orderValueMin: number
    typeVoucherId: number
    reducedAmount: number
    percentDecrease: any
    reducedAmountMaximum: any
    usageCount: number
    dateStart: string
    timeStart: string
    dateEnd: string
    timeEnd: string
    actualStartTime: string
    approvalNote: string //ghi chú phê duyệt
    role: number
    type: number
    view: number
    status: number
    appliedUnitsList: {
        id: number
        title: string
    }[]
    issuedUnit: {
        id: number
        name: string
    }
    approvedUnit: {
        id: number
        name: string
    }
    appliedUnitIds: Array<number>
    appliedBrandIds: Array<number>
    appliedActivityTypeIds: Array<number>
    appliedUnits: string
    appliedBrands: string
    appliedActivities: string
    voucherCustomers: Array<any>
    voucherGroupCustomers: Array<any>
    totalAppliedUnits: number
    totalAppliedBrands: number
    totalAppliedActivities: number
    totalCustomers: number
    totalGroups: number
    termsOfUse: string
    redeemedVoucherQuantity: string
}


export interface IVoucherCode {
    id: number
    code: string
    voucherId: number
    conversionDate: string
    phone: string
    status: number
    customerId: number
    customerName: string
    customerCode: string
    agentId: string
    agentName: string
    usageText: string
    isUsedUp: boolean
    isActive: boolean
    invoiceSaleCode: number
    invoiceServiceCode: number
    unitName: string
}

export interface ILoopupVoucher {
    id: number
    code: string
    customerId: number
    customerName: string
    customerCode: string
    statusConversion: number
    voucherId: number
    title: string
    appliedUnitsList: {
        id: number,
        title: string
    }[]
    description: any
    reducedAmount: any
    percentDecrease: number
    reducedAmountMaximum: number
    usageCount: number
    orderValueMin: number
    dateStart: string
    timeStart: string
    dateEnd: string
    timeEnd: string
    actualStartTime: string
    role: number
    type: number
    view: number
    status: number
    issuedUnit: string
    approvedUnit: string
    appliedUnits: string
    appliedBrands: string
    appliedActivities: string
    totalAppliedUnits: number
    totalAppliedBrands: number
    totalAppliedActivities: number
    totalCustomers: number
    totalGroups: number
    termsOfUse: string
    isUsedUp: boolean
    usageText: string
    hasInvoice: boolean
    typeVoucherId: number
}

export interface IAddVoucherSuccess {
    voucherId: number,
    quantity: number
}


export interface ICustomerConversion {
    customerId: number
    voucherCodeId: number
    invoiceCode: string
    type: number
}

// /voucher/listCustomersRemainByCustomerIds
export const getListCustomersRemainByCustomerForVouhcerIds = async (
    voucherId?: number, customerIds?: number[],
    limit?: number, pageNumber?: number, unitId?: number, unitIds?: number[],
    categoryCarIds?: number[], search?: string,
) => {
    const path = "voucher/listCustomersRemainByCustomerIds"
    const params = {
        voucherId,
        customerIds,

        limit, pageNumber, unitId, unitIds,
        categoryCarIds, search,
    }
    const result: ResponseSuccessTotal<ICustomer[]> = await axiosClient.get(
        path, { params }
    );
    return result;
};

// Tra cuu voucher
export const getLoopupVoucher = async (
    code: string) => {
    const path = "voucher/loopupVoucher"
    const params = {
        code
    }
    const result: ResponseSuccessTotal<ILoopupVoucher> = await axiosClient.get(
        path, { params }
    );
    return result;
};

//Danh sách voucher
export const getListVoucher = async (
    limit?: number, pageNumber?: number,issuedUnitId?: number, search?: string, dateStart?: string, dateEnd?: string) => {
    const path = "voucher/listVoucher"
    const params = {
        limit, pageNumber, issuedUnitId, search, dateStart, dateEnd
    }
    const result: ResponseSuccessTotal<IVoucher[]> = await axiosClient.get(
        path, { params }
    );
    return result;
};

//Thông tin voucher
export const getInfoVoucher = async (
    id: number) => {
    const path = "voucher/infoVoucher"
    const params = {
        id
    }
    const result: ResponseSuccessTotal<IVoucherEdit> = await axiosClient.get(
        path, { params }
    );
    return result;
};


// thêm voucher code cho kh
export const addVoucherCodeCustomer = async (
    voucherId: number, customerId: ISelectedCustomer[]
) => {
    const url = `/voucher/addVoucherCodes`;
    const params = {
        voucherId, customerId
    }
    const result: ResponseSuccess<[]> = await axiosClient.post(
        url, paserParams(params, undefined)
    );
    return result;
}

// thêm KH vào voucher
export const addCustomersVoucher = async (
    voucherId: number, customerId: ISelectedCustomer[]
) => {
    const url = `voucher/addCustomers`;
    const params = {
        voucherId, customerId
    }
    const result: ResponseSuccess<[]> = await axiosClient.post(
        url, paserParams(params, undefined)
    );
    return result;
}


//Thêm mới voucher
export const addVoucher = async (
    title: string, description: string, type: number, orderValueMin: number,
    dateStart: string, timeStart: string, dateEnd: string, timeEnd: string, typeVoucherId: number,
    quantity?: number, issuedUnitId?: number,
    appliedUnitIds?: number[], appliedBrandIds?: number[], appliedActivityTypeIds?: number[],
    approvedUnitId?: number, groupCustomerId?: number[],
    reducedAmount?: number, percentDecrease?: number, reducedAmountMaximum?: number, status?: number,
    termsOfUse?: string
) => {
    const url = `voucher/addVoucher`;
    const params = {
        title, description, type, orderValueMin, dateStart, timeStart, dateEnd, timeEnd, typeVoucherId,
        quantity, issuedUnitId,
        appliedUnitIds, appliedBrandIds, appliedActivityTypeIds,
        approvedUnitId, groupCustomerId,
        reducedAmount, percentDecrease, reducedAmountMaximum, status,
        termsOfUse
    }
    const result: ResponseSuccess<IAddVoucherSuccess> = await axiosClient.post(
        url, paserParams(params, undefined)
    );
    return result;
}

export const conversionVoucher = async (
    customerConversion: ICustomerConversion[], unitId: number, conversionDate: string,
) => {
    const url = `voucher/conversionVoucher`;
    const params = {
        customerConversion, unitId, conversionDate,
    }
    const result: ResponseSuccess<[]> = await axiosClient.put(
        url, params
    );
    return result;
}

//Chỉnh sửa voucher
export const editVoucher = async (
    id: number, title: string, description: string, type: number,
    dateStart: string, timeStart: string, dateEnd: string, timeEnd: string, typeVoucherId: number,
    quantity?: number, issuedUnitId?: number, orderValueMin?: number,
    appliedUnitIds?: number[], appliedBrandIds?: number[], appliedActivityTypeIds?: number[],
    approvedUnitId?: number, groupCustomerId?: number[],
    reducedAmount?: number, percentDecrease?: number, reducedAmountMaximum?: number, status?: number,
    termsOfUse?: string
) => {
    const url = `voucher/editVoucher`;
    const params = {
        id, title, description, type, orderValueMin, dateStart, timeStart, dateEnd, timeEnd, typeVoucherId,
        quantity, issuedUnitId,
        appliedUnitIds, appliedBrandIds, appliedActivityTypeIds,
        approvedUnitId, groupCustomerId,
        reducedAmount, percentDecrease, reducedAmountMaximum, status,
        termsOfUse
    }
    const result: ResponseSuccess<[]> = await axiosClient.put(
        url, paserParams(params, undefined)
    );
    return result;
}

//Xóa voucher
export const deleteVoucher = async (
    id: Number
) => {
    const url = `voucher/deleteVoucher`;
    const params = {
        id
    }
    const result: ResponseSuccess<[]> = await axiosClient.delete(
        url, { params }
    );
    return result;
}

//Cập nhật trạng thái hoạt động voucher
export const updateStatusVoucher = async (
    id: number,
    status?: number, approvalNote?: string
) => {
    const url = `voucher/updateStatusVoucher`;
    const params = {
        id,
        status, approvalNote
    }
    const result: ResponseSuccess<[]> = await axiosClient.put(
        url, paserParams(params, undefined)
    );
    return result;
}

//Cập nhật trạng thái voucher
export const activeVoucher = async (
    id: number
) => {
    const url = `voucher/activeVoucher`;
    const params = {
        id
    }
    const result: ResponseSuccess<[]> = await axiosClient.put(
        url, paserParams(params, undefined)
    );
    return result;
}

//Danh sách mã voucher
export const getListVoucherCode = async (
    voucherId: number, limit?: number, pageNumber?: number, status?: number, search?: string) => {
    const path = "voucher/listVoucherCode"
    const params = {
        voucherId, limit, pageNumber, status, search
    }
    const result: ResponseSuccessTotal<IVoucherCode[]> = await axiosClient.get(
        path, { params }
    );
    return result;
};


//Cập nhật trạng thái mã voucher
export const activeVoucherCode = async (
    id: number
) => {
    const url = `voucher/activeVoucherCode`;
    const params = {
        id
    }
    const result: ResponseSuccess<[]> = await axiosClient.put(
        url, paserParams(params, undefined)
    );
    return result;
}